import Vue from 'vue'
import Vuex from 'vuex'
import camelCase from 'lodash/camelCase'

Vue.use(Vuex);

// auto register modules (/modules)
// Storing in variable a context with all files in folder modules
// ending with `.js`.
const requireModule = require.context('./modules/', true, /\.js$/);
const modules = {};

requireModule.keys().forEach(fileName => {
    if (fileName.includes('types')) return;
    let moduleName = '';

    if (fileName.includes('index')) {
        moduleName = camelCase(
            fileName.replace('./', '').replace('index.js', '')
        )
    } else {
        moduleName = camelCase(
            fileName.replace('./', '').replace('.js', '')
        )
    }
    // create a dynamic object with all modules
    modules[moduleName] = {
        // add namespace here
        namespaced: true,
        ...requireModule(fileName).default
        // if you have exported the object with name in the module `js` file
        // e.g., export const name = {};
        // uncomment this line and comment the above
        // ...requireModule(fileName)[moduleName]
    }
});

// lodash camelCase turns "pointAB" into "pointAb", but the app uses namespace "pointAB"
if (modules.pointAb && !modules.pointAB) {
    modules.pointAB = modules.pointAb
    delete modules.pointAb
}

export default new Vuex.Store({
    modules,
})
